import { atom } from 'jotai';

export const isPreviewOpenAtom = atom(false);
export const previewWindowAtom = atom<Window | null>(null);
